import { useEffect } from "react";
import { sharedEnvironment } from "@akina/config";
import { isApp } from "@akina/utils";

export function usePreventNavigationAndReload() {
  useEffect(() => {
    const isDev = sharedEnvironment.environment === "dev";
    if (!isApp || isDev) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      const isInput = target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;

      if (!["F5", "r", "R", "ArrowRight", "ArrowLeft", "Backspace"].includes(e.key)) return;

      // block refresh event
      if (e.key === "F5") {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "r") {
        e.preventDefault();
      }
      // block keyboard navigation
      if ((e.altKey || e.metaKey) && (e.key === "ArrowRight" || e.key === "ArrowLeft")) {
        e.preventDefault();
      }
      if (e.key === "Backspace" && !isInput) {
        e.preventDefault();
      }
    };

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const handleMouseNavigation = (e: MouseEvent) => {
      // Mouse back button variants
      if (e.button === 3 || e.buttons === 8) {
        e.preventDefault();
        e.stopPropagation();
      }

      // Mouse forward button variants
      if (e.button === 4 || e.buttons === 16) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);
    window.addEventListener("contextmenu", handleContextMenu, true);
    window.addEventListener("mousedown", handleMouseNavigation, true);
    window.addEventListener("mouseup", handleMouseNavigation, true);
    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
      window.removeEventListener("contextmenu", handleContextMenu, true);
      window.removeEventListener("mousedown", handleMouseNavigation, true);
      window.removeEventListener("mouseup", handleMouseNavigation, true);
    };
  }, []);
}
